import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";
const deviceId = localStorage.getItem("deviceId") || uuid();

export const userApi = apiSlice.injectEndpoints({

  endpoints: (builder) => ({
    // GET
    getUser: builder.query({
      providesTags: ["user"],
      query: (body) => {
        return {
          url: "/user",
          method: "POST",
          body,
        };
      },
    }),
    // GET ALL
    getAllUser: builder.query({
      providesTags: ["user"],
      query: () => {
        return {
          url: "/user/list",
          method: "GET",
        };
      },
    }),
    // ADD
    addUser: builder.mutation({
      invalidatesTags: ["user"],
      query: (body) => {
        return {
          url: "/user/signup",
          method: "POST",
          body,
        };
      },
    }),
    // EDIT
    editUser: builder.mutation({
      invalidatesTags: ["user"],
      query: ({ body, userId }) => {
        return {
          url: `/user/${userId}`,
          method: "PUT",
          body,
        };
      },
    }),
    // GET BY ID
    getUserById: builder.query({
      providesTags: ["user"],
      query: (userId) => {
        return {
          url: `/user/${userId}`,
          method: "GET",
        };
      },
    }),
    // STATUS CHANGE
    userStatusChange: builder.mutation({
      invalidatesTags: ["user"],
      query: (userId) => {
        return {
          url: `/user/status-change/${userId}`,
          method: "PUT",
        };
      },
    }),

    //CHANGE SUPER ADMIN PASSWORD
    superAdminPassword: builder.mutation({
      invalidatesTags: ["user"],
      query: (body) => {
        return {
          url: `/user/changed-password`,
          method: 'PUT',
          headers: {
            "device-id": deviceId,
          },
          body
        };
      },
    }),

    //CHANGE ADMIN PASSWORD
    adminChangePassword: builder.mutation({
      invalidatesTags: ["user"],
      query: ({ body, userId }) => {
        return {
          url: `/user/password/${userId}`,
          headers: {
            "device-id": deviceId,
          },
          method: "PUT",
          body,
        };
      },
    }),

    //get All geeksDoor User

    getAllGeeksDoorUser: builder.query({
      providesTags: ["user"],
      query: () => {
        return {
          url: `/user/list`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetUserQuery,
  useAddUserMutation,
  useEditUserMutation,
  useGetUserByIdQuery,
  useUserStatusChangeMutation,
  useSuperAdminPasswordMutation,
  useAdminChangePasswordMutation,
  useGetAllGeeksDoorUserQuery,
  useGetAllUserQuery
} = userApi;
